import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { AppLayout } from "../../../components/layout/AppLayout"
import { Button } from "../../../components/ui/button"
import {
  FiscalSettingForm,
  type CompanyOmieOption,
  type FiscalSettingFormValues
} from "../../../features/clients/FiscalSettingForm"

type ClientSummary = {
  id: number
  cliente: string
  razao_social_tomador: string
}

type Props = {
  client: ClientSummary
  fiscal_setting: FiscalSettingFormValues
  companies: CompanyOmieOption[]
  errors?: Record<string, string[]>
}

export default function FiscalSettingsNew({ client, fiscal_setting, companies, errors }: Props) {
  const base = `/clientes/${client.id}/configuracoes-fiscais`

  return (
    <>
      <Head title="Nova configuração fiscal" />
      <AppLayout>
        <div className="mx-auto w-full max-w-4xl p-8">
          <div className="mb-6 flex items-center gap-3">
            <Button asChild variant="outline" className="border-slate-700 bg-transparent">
              <Link href={base}>
                <ArrowLeft className="h-4 w-4" />
              </Link>
            </Button>
            <div>
              <h1 className="text-2xl font-bold text-white">Nova configuração fiscal</h1>
              <p className="text-slate-400">{client.cliente}</p>
            </div>
          </div>
          <FiscalSettingForm
            initialValues={fiscal_setting}
            companies={companies}
            submitUrl={base}
            submitLabel="Salvar configuração"
            method="post"
            errors={errors}
            cancelHref={base}
          />
        </div>
      </AppLayout>
    </>
  )
}
